import { motion } from 'framer-motion';
import { Typography } from '@tempmee/react';
import { CenteredSpinner } from '../CenteredSpinner';
import { colors } from '@tempmee/tailwind';
import { IOptionValue, TValueChangeCallback } from './interfaces';

interface IProps<T> {
  data: IOptionValue<T>[];
  isSearching: boolean;
  onChange: TValueChangeCallback<T>;
}

export const OptionList = <T,>({ data, isSearching, onChange }: IProps<T>) => {
  if (isSearching) {
    return <CenteredSpinner />;
  }

  if (data.length === 0) {
    return (
      <Typography as="span" color={colors.neutral[500]} size="caption" textAlign="center">
        No results found
      </Typography>
    );
  }

  return (
    <>
      {data.map((it) => (
        <motion.div
          className="options-item"
          data-value={it.value}
          key={it.value as any}
          onClick={() => onChange(it)}
        >
          <Typography as="span" style={{ color: 'inherit' }}>
            {it.label}
          </Typography>
        </motion.div>
      ))}
    </>
  );
};
